import InfoModal from '@/components/molecules/InfoModal';
import ACCreationForm from '@/components/organisms/ACCreationForm';
import { setBreadcrumbs } from '@/store/slices/breadcrumb';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { accountingCenterService } from '@/services/accounting-centers.service';
import toast from 'react-hot-toast';

function formatACType(acType: string) {
  return acType
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

const ACAddPage = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { budgetId, acType } = useParams();

  useEffect(() => {
    // Set breadcrumbs when component mounts
    dispatch(
      setBreadcrumbs([
        {
          title: 'Budget',
          path: `/budgets/${budgetId}`
        },
        {
          title: formatACType(acType || '') + ' AC Overview',
          path: ``
        }
      ])
    );
  }, [dispatch, budgetId]);

  const handleSubmit = async (data: any) => {
    console.log('Submit', data);
    try {
      if (!budgetId) {
        throw new Error('BudgetId is required');
      }
      const response = await accountingCenterService.createAccountingCenter(budgetId, {
        ...data,
        type: acType?.toUpperCase()
      });
      console.log('Response', response);
      toast.success('Accounting center created successfully');
      navigate(`/budgets/${budgetId}/accounting-centers/${acType}`);
    } catch (error) {
      console.error('Error creating accounting center:', error);
    }
  };

  return (
    <>
      <div className=" bg-[#FBFBFF] p-4 flex flex-col flex-1 md:bg-white rounded-[16px] border">
        <h2 className="text-center font-semibold mb-5 md:text-left md:text-[24px] md:mb-6">
          Create your Department Accounting Center
        </h2>

        {/* FORM */}
        <ACCreationForm onSubmit={handleSubmit} />
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <InfoModal
          isOpen={showSuccessModal}
          variant="success"
          title="Bank Account Created"
          message={<p>You have successfully created a Bank Account!</p>}
          buttonText="Go to Bank Account"
          onButtonClick={() => {}}
        />
      )}
    </>
  );
};

export default ACAddPage;
